import actions from '../../actionTypes';

export default (areaId) => {
  return {
    type: actions.EDIT_AREA_LOAD,
    areaId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/areas/actions/editAreaLoad.js